export default __webpack_public_path__ + "pgnv-assets/bcca53281f5b2361b187359ebd11e7a3.png";